/**
 * 디바이스 코드를 가져오는 함수
 * @returns {string|null} 디바이스 코드 또는 null
 */
export const getDeviceCode = () => {
    try {
        return window.BRIDGE?.getDeviceCode?.() || null;
    } catch (error) {
        console.error('디바이스 코드 가져오기 실패:', error);
        return null;
    }
};

/**
 * 배출 명령을 실행하는 함수
 * @param {string} base64EncodedString 인코딩된 데이터
 * @param {string|null} base64PortMap 인코딩된 포트 맵
 * @returns {boolean} 성공 여부
 */
export const executeSendOut = (base64EncodedString, base64PortMap = null) => {
    try {
        if (window.BRIDGE?.executeSendOut) {
            window.BRIDGE.executeSendOut(base64EncodedString, base64PortMap);
            return true;
        } else if (window.BRIDGE?.sendOut) {
            // 하위 호환성
            window.BRIDGE.sendOut(base64EncodedString);
            return true;
        }
        return false;
    } catch (error) {
        console.error('배출 명령 실행 중 오류:', error);
        return false;
    }
};

/**
 * 콜백 함수를 전역 스코프에 안전하게 등록하는 유틸리티
 * @param {string} name 전역 함수 이름
 * @param {Function} callback 콜백 함수
 * @returns {Function} 등록 해제 함수
 */
export const registerGlobalCallback = (name, callback) => {
    // 기존 함수 백업
    const originalFn = window[name];

    // 새 함수 등록
    window[name] = (...args) => {
        if (typeof callback === 'function') {
            return callback(...args);
        }
        return undefined;
    };

    // 해제 함수 반환
    return () => {
        if (originalFn) {
            window[name] = originalFn;
        } else {
            delete window[name];
        }
    };
};